import { render, staticRenderFns } from "./RecomVoucher.vue?vue&type=template&id=20803569"
import script from "./RecomVoucher.vue?vue&type=script&lang=js"
export * from "./RecomVoucher.vue?vue&type=script&lang=js"
import style0 from "./RecomVoucher.vue?vue&type=style&index=0&id=20803569&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports